<script>
export default {
    name: 'Marquee',
    functional: true,
    props: {
        duration: {
            type: Number,
            default: 15
        },
        repeat: {
            type: Number,
            default: 2,
            validator: function (val) {
                return val > 0
            }
        },
        paused: {
            type: Boolean,
            default: false
        },
        reverse: {
            type: Boolean,
            default: false
        }
    },
    render(
        h,
        {
            $style,
            props: { duration, repeat, paused, reverse },
            children,
            data: { staticClass, key, on }
        }
    ) {
        const text = h(
            'div',
            {
                class: 'item',
                style: {
                    animationDuration: `${duration}s`,
                    animationDirection: reverse ? 'reverse' : undefined,
                    display: 'flex'
                }
            },
            children
        )
        return h(
            'div',
            {
                key,
                on,
                class: [staticClass, 'wrap']
            },
            [
                h(
                    'div',
                    {
                        class: [paused ? 'paused' : undefined, 'content']
                    },
                    Array(repeat).fill(text)
                )
            ]
        )
    }
}
</script>

<style lang="scss" scoped>
.wrap {
    overflow: hidden;
}

.content {
    width: 999999px;
}

.item {
    animation-name: animation;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    float: left;
}

.paused .item {
    animation-play-state: paused;
}

@keyframes animation {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-100%);
    }
}
</style>